// Layout.js
import Button from 'components/Button';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { logout } from 'slice/userSlice';
import { useDispatch } from 'react-redux';
import { IoPersonCircleSharp } from "react-icons/io5";
import { MdContacts } from "react-icons/md";
import { FaUsers, FaCalendarAlt , FaEnvelope , FaRegNewspaper , FaBriefcase, FaShoppingBag } from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import logo from '../asserts/img/logo.png'
// import Header from './Header';
// import Footer from './Footer';
// import { linklists, headersClasses } from './RouterList';
const currentUrl = window.location.pathname;
const lastSegment = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);

const Layout = ({ children }) => {
    const [toggled, setToggle] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);
    const dispatch = useDispatch();
    const nevigate = useNavigate();

    const toggleMenu = (menu) => {
        setOpenMenu(openMenu === menu ? null : menu);
    };

    const logoutHandler = async (e) => {
        e.preventDefault();
        try {
            dispatch(logout());
            nevigate('/signin');
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <>
       

            <div id="wrapper">
                <ul className={toggled ? 'navbar-nav sidebar sidebar-dark toggled' : 'navbar-nav sidebar sidebar-dark accordion'} id="accordionSidebar">
                    <Link className="text-decoration-none justify-content-start" to="/dashboard">
                        <div className="text-center">
                            <img src={logo} alt='adminlogo' className='img-fluid adminlogo' />
                        </div>
                    </Link>
                    {/* <hr className="sidebar-divider my-0" /> */}
                    <li className="nav-item text-dark">
                        <Link className="nav-link" to="/dashboard">
                            <MdDashboard className='mr-1' />
                            <span>Dashboard</span>
                        </Link>
                    </li>


                    {/* resume */}
                    <li className={`nav-item text-dark ${lastSegment === 'internship_portal' ? 'active' : ''}`}>
                        <Link
                            className="nav-link text-dark collapsed"
                            href="#"
                            data-toggle="collapse"
                            aria-expanded={openMenu === 'internship_portal'}
                            onClick={() => toggleMenu('internship_portal')}
                        >
                            <FaCalendarAlt className='mr-1' />
                            <span>Intership Apply </span>
                        </Link>
                        <div
                            id="internship_portal"
                            className={`collapse ${openMenu === 'internship_portal' ? 'show' : ''}`}
                            aria-labelledby="headingTwo"
                        >
                            <div className="bg-white py-2 collapse-inner rounded">
                                <Link className="collapse-item" to="/internship_portal">Internship Apply List</Link>
                            </div>
                        </div>
                    </li>

                    {/* enquary  */}
                    <li
                        className={`nav-item text-dark ${lastSegment === 'enquire' ? 'active' : ''}`}
                    >
                        <Link
                            className="nav-link text-dark collapsed"
                            href="#"
                            data-toggle="collapse"
                            aria-expanded={openMenu === 'enquire'}
                            onClick={() => toggleMenu('enquire')}
                        >
                            <FaEnvelope className="mr-1" /> 
                            <span>Job Apply</span>
                        </Link>

                        <div
                            id="enquire"
                            className={`collapse ${openMenu === 'enquire' ? 'show' : ''}`}
                            aria-labelledby="headingEnquire"
                        >
                            <div className="bg-white py-2 collapse-inner rounded">
                                <Link className="collapse-item" to="/enquire">
                                    Job Apply List
                                </Link>
                            </div>
                        </div>
                    </li>


                    {/* Our Team */}
                    <li className={`nav-item text-dark ${lastSegment === 'ourteam' ? 'active' : ''}`}>
                        <Link
                            className="nav-link text-dark collapsed"
                            href="#"
                            data-toggle="collapse"
                            aria-expanded={openMenu === 'ourteam'}
                            onClick={() => toggleMenu('ourteam')}
                        >
                            <FaUsers className='mr-1' />
                            <span>Our Team</span>
                        </Link>
                        <div
                            id="ourteam"
                            className={`collapse ${openMenu === 'ourteam' ? 'show' : ''}`}
                            aria-labelledby="headingTwo"
                        >
                            <div className="bg-white py-2 collapse-inner rounded">
                                <Link className="collapse-item" to="/ourteam/add">Add Our Team</Link>
                                <Link className="collapse-item" to="/ourteam">Our Team List</Link>
                            </div>
                        </div>
                    </li>

                    {/* job  */}
          <li className={`nav-item text-dark ${lastSegment === 'job' ? 'active' : ''}`}>
            <Link
              className="nav-link text-dark collapsed"
              href="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'job'}
              onClick={() => toggleMenu('job')}
            >
              <FaBriefcase className="mr-1" />
              <span>Add Vacancy</span>
            </Link>
            <div id="job" className={`collapse ${openMenu === 'job' ? 'show' : ''}`} aria-labelledby="headingJob">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/jobs/add">
                  Add Job
                </Link>
                <Link className="collapse-item" to="/jobs">
                  Job List
                </Link>
              </div>
            </div>
          </li>

                       {/* our Blog     */}
          <li className={`nav-item text-dark ${lastSegment === 'blog' ? 'active' : ''}`}>
            <Link
              className="nav-link text-dark collapsed"
              href="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'blog'}
              onClick={() => toggleMenu('blog')}
            >
              <FaRegNewspaper className="mr-1" /> {/* icon for Blog */}
              <span>Blog</span>
            </Link>
            <div
              id="blog"
              className={`collapse ${openMenu === 'blog' ? 'show' : ''}`}
              aria-labelledby="headingBlog"
            >
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/blog/add">
                  Add Blog
                </Link>
                <Link className="collapse-item" to="/blog">
                  Blog List
                </Link>
              </div>
            </div>
          </li>

          {/* Payments / Orders */}
          <li className={`nav-item ${lastSegment === 'payments' ? 'active' : ''}`}>
              <Link className="nav-link text-dark" to="/payments">
                  <FaShoppingBag className="mr-1" />
                  <span>Online Orders (Payments)</span>
              </Link>
          </li>




                    {/* Contact Us */}
                    <li className={`nav-item ${lastSegment === 'contactus' ? 'active' : ''}`}>
                        <Link
                            className="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            aria-expanded={openMenu === 'contactus'}
                            onClick={() => toggleMenu('contactus')}
                        >
                            <MdContacts className='mr-1' />
                            <span>Contact Us</span>
                        </Link>
                        <div
                            id="contactus"
                            className={`collapse ${openMenu === 'contactus' ? 'show' : ''}`}
                            aria-labelledby="headingTwo"
                        >
                            <div className="bg-white py-2 collapse-inner rounded">
                                <Link className="collapse-item text-dark" to="/contactus">Contact Us List</Link>
                            </div>
                        </div>
                    </li>

                    <div className="text-center text-dark d-none d-md-inline mt-5">
                        <button className="rounded-circle border-0 text-dark" id="sidebarToggle" onClick={() => setToggle(!toggled)}></button>
                    </div>
                </ul>

                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content" className="glass p-4">

                        <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
                            <button id="sidebarToggleTop" onClick={() => setToggle(!toggled)} className="btn btn-link d-md-none rounded-circle mr-3">
                                <i className="fa fa-bars"></i>
                            </button>
                            <ul className="navbar-nav ml-auto">
                                {/* <div className="topbar-divider d-none d-sm-block"></div> */}
                                <li className="nav-item dropdown no-arrow">
                                    <Link className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span className="mr-2 d-none d-lg-inline admintext small">Admin</span>
                                        <IoPersonCircleSharp size={20} style={{ color: "#073980" }} />
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                                        aria-labelledby="userDropdown">
                                        <div className="dropdown-divider"></div>
                                        <Button className="dropdown-item" text='Logout' onclickfun={logoutHandler} />
                                        <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                    </div>
                                </li>
                            </ul>
                        </nav>
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Layout;
